// Copyright (c) 2016 Deere & Company

import './pencil-icon.scss';
import React, {PropTypes} from 'react';

const PencilIcon = props =>
    <div className='pencil-icon-comp'>
        <span
            className='pencil-icon'
            onClick={props.onEdit}
        />
    </div>;

PencilIcon.displayName = 'PencilIcon';
PencilIcon.propTypes = {
    onEdit: PropTypes.func
};

export default PencilIcon;



// WEBPACK FOOTER //
// ./src/shared/components/pencil-icon/index.js